import React from 'react'
import dropzone from 'react-dropzone'
import useMount from 'react-use/lib/useMount'
import { Field } from 'redux-form'
import Radio from 'components/Input/Radio'
import Button from 'components/Button'
import LoadingOverlay from 'components/Loading/LoadingOverlay'
import { Table, TableRow } from 'features/Table'
import { PrevNextButtons } from '../PrevNextButtons'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import s from './UploadDocumentsStep.scss'

import { IUploadedFile } from './UploadDocumentsStep.container'
import { IStepCommonProps } from 'features/MobileServices/MobileServiceForm'

const Dropzone = dropzone.default

export const UploadDocumentsStepComponent = (
  props: IStepCommonProps & { name: string; uploadMobileServiceDocument: Function }
) => {
  const {
    name,
    onBack,
    loading,
    change,
    formData,
    uploadMobileServiceDocument,
    setHeadings,
  } = props

  const uploadedFiles = formData.uploadedFiles || []
  const hasUploadedFiles = uploadedFiles.length > 0 || false

  useMount(() => {
    setHeadings &&
      setHeadings({
        heading: 'Now the Important part and this is a requirement from the Australian Government.',
        subHeading:
          'When you select either Individual or Business below, we will need you to upload your approved ID so that we can get your services live, don’t worry this is just required the first time.',
      })
  })

  const uploadFiles = (filesToUpload: string[]) => {
    Promise.allSettled(
      filesToUpload.map(file =>
        uploadMobileServiceDocument({ file, id: name }).then(data => ({
          file: file,
          hash: data.action.payload.data.hash,
        }))
      )
    ).then(results => {
      change(
        'uploadedFiles',
        ([] as IUploadedFile[]).concat(
          uploadedFiles,
          results
            .filter(result => result.status === 'fulfilled')
            .map(result => result.status === 'fulfilled' && result.value)
        )
      )
    })
  }

  const deleteFile = hash => {
    change(
      'uploadedFiles',
      uploadedFiles.filter(file => file.hash !== hash)
    )
  }

  const endUserTypeName = 'endUserType'
  const endUserType = formData.endUserType

  return (
    <div>
      <div className={s.endUserType}>
        <div className={cn(sText.descrip1, sText.center, s.header)}>
          End-User of the Virtual Mobile App
        </div>

        <Field
          className={s.radio}
          name={endUserTypeName}
          radioValue="individual"
          component={Radio}
          label="Individual"
          afterChange={value => change(endUserTypeName, value)}
        />
        <p>An individual will make or receive calls with the virtual mobile service.</p>

        <Field
          className={s.radio}
          name={endUserTypeName}
          radioValue="business"
          component={Radio}
          label="Business"
          afterChange={value => change(endUserTypeName, value)}
        />
        <p>A business will make or receive calls with the virtual mobile service.</p>
      </div>

      {endUserType && (
        <>
          <div className={cn(sText.descrip1, sText.center, s.header)}>
            Upload Supporting Documents
          </div>
          <div style={{ position: 'relative' }}>
            <Dropzone id={name} className={s.dropzone} onDrop={uploadFiles}>
              Click or Drag files here
            </Dropzone>
            {loading && <LoadingOverlay />}
          </div>
        </>
      )}

      {hasUploadedFiles && (
        <Table>
          {uploadedFiles.map(file => (
            <TableRow key={file.hash}>
              <div>{file.file.name}</div>

              <div style={{ maxWidth: '85px' }}>
                <Button color="warn" size="xs" ghost onClick={() => deleteFile(file.hash)}>
                  Delete
                </Button>
              </div>
            </TableRow>
          ))}
        </Table>
      )}

      {endUserType === 'business' && (
        <div className={s.info}>
          <p className={s.subHeader}>Information required</p>
          <ul className={s.list}>
            <li>Business ID Number</li>
            <li>Business Name</li>
            <li>Business Address (Proof of Address)</li>
          </ul>

          <p className={s.subHeader}>Acceptable supporting documents</p>
          <ul className={s.list}>
            <li>ASIC company extracts</li>
            <li>Commercial registry and bank statement</li>
            <li>Commercial registry and proof of address</li>
          </ul>

          <p>
            For more information please visit our{' '}
            <Button
              plain
              target="_blank"
              href="https://helpcentre.thinkpickle.com.au/en/articles/3996826-virtual-mobile-number-regulations"
            >
              article
            </Button>
          </p>
        </div>
      )}

      {endUserType === 'individual' && (
        <div className={s.info}>
          <p className={s.subHeader}>Information required</p>
          <ul className={s.list}>
            <li>Proof of Identity</li>
            <li>Proof of Address</li>
          </ul>

          <p className={s.subHeader}>Acceptable supporting documents</p>
          <ul className={s.list}>
            <li>Valid Australian drivers licence/photo card</li>
          </ul>
          <p className={s.subHeader}>Or</p>
          <p>
            Two forms of ID
            <br />
            <br />
            Proof of identity (Current)
          </p>
          <ul className={s.list}>
            <li>Government-issued ID</li>
            <li>Passport</li>
          </ul>
          <p>Proof of Address (Within last 3 months)</p>
          <ul className={s.list}>
            <li>Utility Bill</li>
            <li>Tax Notice</li>
            <li>Rent Receipt</li>
            <li>Council Rates</li>
          </ul>
          <p>
            For more information please visit our{' '}
            <Button
              plain
              target="_blank"
              href="https://helpcentre.thinkpickle.com.au/en/articles/3996826-virtual-mobile-number-regulations"
            >
              article
            </Button>
          </p>
        </div>
      )}

      <PrevNextButtons
        onBack={onBack}
        loading={loading}
        disabled={!hasUploadedFiles || !endUserType || loading}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/MobileServices/MobileServiceForm/UploadDocumentsStep/UploadDocumentsStep.tsx